import { getWebInstrumentations, initializeFaro } from "@grafana/faro-web-sdk";

// Sends uncaught errors, console warnings/errors and web vitals to Grafana (Loki) via the Faro
// receiver. Off unless the stack sets REACT_APP_FARO_URL, so one image serves every tenant.
// environment = the tenant (kons15.pondoo.ai → "kons15"); Alloy turns it into the `customer` label.
const url = window._env_.REACT_APP_FARO_URL;

if (url) {
  initializeFaro({
    url,
    app: {
      name: "operator",
      environment: window.location.hostname.split(".")[0],
    },
    // Per-request resource timings would flood Loki; errors and web vitals are what we want.
    instrumentations: getWebInstrumentations({
      enablePerformanceInstrumentation: false,
    }),
  });
}
